import { useGlobalContext } from "../context";
import Product from "./Product";

function ProductList() {
  const { products, setCategory } = useGlobalContext();

  // if (products.length < 1) {
  //   return <Loading />;
  // }

  const filterProducts = (category) => {
    setCategory(category);
  };

  return (
    <div
      style={{ marginTop: "2rem" }}
      className="container d-flex flex-row justify-content-around flex-wrap"
    >
      <div
        style={{ width: "90%" }}
        className="btn-group"
        role="group"
        aria-label="Basic example"
      >
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => filterProducts("dairy")}
        >
          Dairy
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => filterProducts("fruit")}
        >
          Fruits
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => filterProducts("vegetable")}
        >
          Vegetables
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => filterProducts("snacks")}
        >
          Snacks
        </button>
        <button
          type="button"
          className="btn btn-warning"
          onClick={() => filterProducts("")}
        >
          All
        </button>
      </div>
      <div
        className="container d-flex flex-row justify-content-around flex-wrap"
        style={{
          height: "35rem",
          marginTop: "3rem",
          marginBottom: "4rem",
          overflow: "scroll",
          backgroundColor: "#889ebf"
        }}
      >
        {products.map((product) => {
          return <Product key={product._id} {...product} />;
        })}
      </div>
    </div>
  );
}

export default ProductList;
